import { render, staticRenderFns } from "./CompareButton.vue?vue&type=template&id=d70cd336"
import script from "./CompareButton.vue?vue&type=script&lang=js"
export * from "./CompareButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports